export default __webpack_public_path__ + "static/media/LUPA.2b615da2.svg";